import { EmptyStateProps, EmptyStateActionsProps, EmptyStateDescriptionsProps, EmptyStateImageProps, EmptyStateTitleProps } from '@procore/core-react/dist/_typedoc/EmptyState/EmptyState.types.json';
import * as React from 'react';
export default {
  EmptyStateProps,
  EmptyStateActionsProps,
  EmptyStateDescriptionsProps,
  EmptyStateImageProps,
  EmptyStateTitleProps,
  React
};